module.exports = __webpack_public_path__ + "static/media/plan-507+508-mobile-sc.0fe8ace7.png";